import { render, staticRenderFns } from "./importModel.vue?vue&type=template&id=4c3dafd5&scoped=true&"
import script from "./importModel.vue?vue&type=script&lang=js&"
export * from "./importModel.vue?vue&type=script&lang=js&"
import style0 from "./importModel.vue?vue&type=style&index=0&id=4c3dafd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3dafd5",
  null
  
)

export default component.exports